import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { checkBoxHelper } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { getCoopDettagliantiControl } from './helpers/coop-dettaglianti-form.helpers';

export const schedaCoopDettagliantiRules: FormGroupRules = {
    my_SchDettAcqColl: (form: FormGroup) => {
        ckHelper(form, 'my_SchDettAcqColl', 'my_CkSchDettAcqColl', 1);
    },

    my_SchDettServAmm: (form: FormGroup) => {
        ckHelper(form, 'my_SchDettServAmm', 'my_CkSchDettServAmm', 1);
    },

    my_SchDettServFin: (form: FormGroup) => {
        ckHelper(form, 'my_SchDettServFin', 'my_CkSchDettServFin', 1);
    },

    my_SchDettGestMercRion: (form: FormGroup) => {
        ckHelper(form, 'my_SchDettGestMercRion', 'my_CkSchDettGestMercRion', 1);
    },

    my_SchDettLogistica: (form: FormGroup) => {
        ckHelper(form, 'my_SchDettLogistica', 'my_CkSchDettLogistica', 1);
    },

    my_SchDettAltro: (form: FormGroup) => {
        ckHelper(form, 'my_SchDettAltro', 'my_CkSchDettAltro', 1);
    },

    my_SchDettNoteOsserv: (form: FormGroup) => {
        ckHelper(form, 'my_SchDettNoteOsserv', 'my_CkSchDettNoteOsserv', 1);
    },

    my_CkSchDettAcqColl: (form: FormGroup) => {
        requiredByScCoopDettagliObbl(form, 'my_CkSchDettAcqColl');
    },

    my_CkSchDettServAmm: (form: FormGroup) => {
        requiredByScCoopDettagliObbl(form, 'my_CkSchDettServAmm');
    },

    my_CkSchDettServFin: (form: FormGroup) => {
        requiredByScCoopDettagliObbl(form, 'my_CkSchDettServFin');
    },

    my_CkSchDettGestMercRion: (form: FormGroup) => {
        requiredByScCoopDettagliObbl(form, 'my_CkSchDettGestMercRion');
    },

    my_CkSchDettLogistica: (form: FormGroup) => {
        requiredByScCoopDettagliObbl(form, 'my_CkSchDettLogistica');
    },

    my_CkSchDettAltro: (form: FormGroup) => {
        requiredByScCoopDettagliObbl(form, 'my_CkSchDettAltro');
    },

    my_CkSchDettNoteOsserv: (form: FormGroup) => {
        requiredByScCoopDettagliObbl(form, 'my_CkSchDettNoteOsserv');
    },
};

const ckHelper = (form: FormGroup, targetPath: string, ckPath: string, ckTargetValue: number, suppCondition = true, errorStatus?: string): void => {
    const scCoopDettagliObbl: string = getCoopDettagliantiControl(form, 'my_ScCoopDettagliObbl').value;
    checkBoxHelper(form, targetPath, ckPath, ckTargetValue, formPaths.schedaCoopDettaglianti, suppCondition && scCoopDettagliObbl === '1', errorStatus);
};

const requiredByScCoopDettagliObbl = (form: FormGroup, targetPath: string): void => {
    checkBoxHelper(form, targetPath, 'my_ScCoopDettagliObbl', 1, formPaths.schedaCoopDettaglianti);
};

export const CoopDettagliantiFormValidators = Object.values(schedaCoopDettagliantiRules);
